<template>
  <section class="base-container-first page-header">
    <div class="page-header__container">
      <BaseLink
        class="page-header__link"
        :href="`/${locale}`"
      >
        <BaseIcon2
          id="icon-arrow"
          class="page-header__link-icon"
          height="24"
          width="24"
        />
      </BaseLink>

      <h2
        class="page-header__title typography__headline2"
        v-html="title"
      />
    </div>

    <picture>
      <source
        media="(min-width: 769px)"
        srcset="/images/gradient-background.svg"
      />

      <img
        alt=""
        class="page-header__gradient"
        height="308"
        src="/images/gradient-background-mobile.svg"
        width="430"
      />
    </picture>
  </section>
</template>

<script setup lang="ts">
const { locale } = useI18n();

interface Props {
  title: string;
}

defineProps<Props>();
</script>

<style scoped>
.page-header {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 auto;
  padding-bottom: 24px;
  overflow: hidden;
}

@media (--desktop) {
  .page-header {
    column-gap: 40px;
  }
}

.page-header__container {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  max-width: 370px;
  padding-top: 60px;
  padding-bottom: 120px;
}

@media (--laptop) {
  .page-header__container {
    row-gap: 24px;
    max-width: 535px;
    padding-top: 0;
    padding-bottom: 0;
  }
}

.page-header__link {
  width: min-content;
  padding: 6px 24px;
  color: var(--grey-1-5);
  border-radius: 30px;
  background-color: var(--grey-6);
}

@media (--hover) {
  .page-header__link:hover {
    background-color: var(--grey-7);
  }

  .page-header__link:active {
    background-color: var(--grey-5);
  }
}

.page-header__link-icon {
  rotate: 180deg;
}

@media (--desktop) {
  .page-header__title {
    font-size: 60px;
    line-height: 1.1;
  }
}

.page-header__gradient {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}

@media (--laptop) {
  .page-header__gradient {
    position: static;
    transform: translateY(0);
    width: 623px;
    height: 520px;
    margin-right: 0;
  }
}
</style>
